<template>
  <div class="story-page">
    <div class="toprow">
        <img src="../assets/FNXAlliance.png"/>
        <div><h1>[1599](FNX)/(LOV) Fenix/League of Villains</h1></div>
        
    </div>
    <div class="welcome">
        <p>Welcome, fellow alliance members, to the little space I am renting
            on the internet!  Playing KC with you has been so fun, and I have 
            greatly enjoyed it.  I had no intention of making these stories public,
            since it was just for fun, but I wanted all my KC friends to be able
            to read it.  Below you will find the steamy slow burn romance, Northern
            Skies, and the action thriller, Playing the Game.  I hope you find it as
            enjoyable as I do.  If you have any ideas
            on content to add, or want anything changed, just let me know.
        </p>
       
        <p>Bem-vindos, companheiros da aliança, a este pequeno espaço que estou alugando
na internet! Jogar KC com vocês tem sido muito divertido, e eu tenho
gostado muito. Eu não tinha a intenção de tornar essas histórias públicas,
já que era apenas por diversão, mas queria que todos os meus amigos do KC pudessem
lê-las. Abaixo vocês encontrarão o romance sensual e envolvente, Northern
Skies, e o thriller de ação, Playing the Game. Espero que vocês gostem tanto
quanto eu. Se tiverem alguma ideia
de conteúdo para adicionar ou quiserem que algo seja alterado, é só me avisar.

        </p>
    </div>
    <hr>
    <div style="text-align: left;">
      <h2>FanFics</h2>
    <router-link to="/northernskies" style="text-indent: 50px"><h3>Northern Skies</h3></router-link>
    <router-link to="/playingthegame" style="text-indent: 50px"><h3>Playing the Game</h3></router-link>
    </div>

      

  </div>
</template>

<script>
export default {
  name: 'StoryView',
  data() {
    return {
      storyTitle: 'Northern Skies: A KC Love Story',
      chapters: [
        {
          id: 'chapter-1',
          chapterNumber: 1,
          title: `Hard Knocks at the Hard ROCs`,
          content: ``,
          isAvailable: true, // Set to false to hide it
        },
        {
          id: 'chapter-2',
          chapterNumber: 2,
          title: 'Keeping an EYE on Things',
          content: ``,
          isAvailable: true,
        },
        {
          id: 'chapter-3',
          chapterNumber: 3,
          title: 'Down in the Dungeon',
          content: '<p>The sun rose over the mountains...</p>',
          isAvailable: false, // This chapter is not yet released
        },
        // Add more chapters here as they are released
      ],
      isMenuVisible: false, // Start with the mobile menu hidden
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuVisible = !this.isMenuVisible;
    },
    handleResize() {
      // Show the menu by default on large screens
      this.isMenuVisible = window.innerWidth > 768;
    },
    scrollToChapter(chapterId) {
      const element = document.getElementById(chapterId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        // Close the menu after clicking a link
        if (window.innerWidth <= 768) {
          this.isMenuVisible = false;
        }
      }
    },
    /*rateChapter(chapterId, rating) {
      console.log(`User rated chapter ${chapterId} with a ${rating}.`);
    },*/
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize(); // Call it once on mount to set initial state
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style scoped>

.story-page {
  max-width: 800px;
  margin: 0 auto;
  font-family: 'Georgia', serif;
}

.story-header {
  position: sticky;
  top: 0;
  background: white;
  z-index: 10;
  padding: 10px 0;
  border-bottom: 1px solid #ccc;
}
.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 800px;
  margin: 0 auto;
}
/* Base styles for navigation (desktop-first approach) */
.chapter-navigation {
  display: block; /* By default, show navigation */
  margin-top: 10px;
}
.quick-links {
  list-style-type: none;
  padding: 10;
  flex-wrap: wrap;
  gap: 15px;
  text-align: center;
}

.quick-links li {
  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
  padding: 10px;
}

.quick-links a {
  text-decoration: none;
  color: #007bff;
  font-weight: bold;
}

.disabled-link a {
  color: #888;
  pointer-events: none;
}

.rating-buttons {
  display: flex;
  gap: 2px;
}

.thumbs-up, .thumbs-down {
  background: none;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
  padding: 0;
}

.story-content {
  margin-top: 20px;
}

.chapter-section {
  margin-bottom: 40px;
}

.chapter-text {
  text-align: justify;
  line-height: 1.6;
  font-size: 1.1rem;
}
.chapter-text p {
    text-indent: 4em;
    padding: 0;
    margin-bottom: 0em
}
.toprow{
  display: flex;
  align-items: center;
  text-align: left;
  max-height:190px;
  background-color: #d6d6c2;
}
h1 {
  display: flex;
  font-size:40px;
  padding:10px 10px;
  max-height:90px;
}
.toprow img {
  display: flex;
  width: 87px;
  height:107px;
}
.welcome p {
    padding: 5px;
    line-height: 1.6;
    text-align: justify;
}


.hamburger-button, .close-button {
  background: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  display: none; /* Hide by default on large screens */
}

@media (max-width: 768px) {
  .header-container {
    flex-direction: column;
  }

  .hamburger-button {
    display: block; /* Show hamburger button */
  }
  
  /* Hide the full navigation menu initially on mobile */
  .chapter-navigation {
    display: none;
    position: fixed;
    top: 0;
    right: 0;
    width: 250px;
    height: 100%;
    background: #f8f9fa;
    padding: 20px;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.2);
    z-index: 20;
    flex-direction: column;
    align-items: flex-start;
  }

  /* When 'isMenuVisible' is true, show the mobile menu with a slide-in animation */
  .chapter-navigation.mobile-nav-visible {
    display: flex; /* Override display: none */
    animation: slideIn 0.3s forwards;
  }

  .quick-links {
    flex-direction: column;
    gap: 10px;
  }

  /* Show the close button on mobile */
  .close-button {
    display: block;
    align-self: flex-end; /* Align the close button to the top-right */
  }

  /* Optional: Animation for the slide-in menu */
  @keyframes slideIn {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }

}
</style>